export default __webpack_public_path__ + "static/media/logo_tejarati.3f76dbe6.png";